var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "footer-email-collection",
      style: { "background-color": _vm.backgroundColor, color: _vm.fontColor }
    },
    [
      _c("div", { staticClass: "footer-email-collection__content" }, [
        _c(
          "div",
          { staticClass: "footer-email-collection__form" },
          [_vm._t("default")],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }